<template>
  <div class="tab">
    <el-footer
      v-if="$can('create', 'dvr_servers')"
      class="tab__footer page__active_bar"
    >
      <el-button
        class="page__active_button"
        icon="el-icon-plus"
        type="primary"
        @click="$router.push({ name: 'servers:create' })"
      >
        Добавить
      </el-button>
    </el-footer>
    <div class="page_container">
      <search
        :query.sync="query"
        @search="search"
      />
      <servers-table />
      <el-pagination
        class="list__pagination"
        layout="prev, pager, next"
        :page-size="count"
        :total="total"
        :current-page="page"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import Search from "@/components/Search/index";
import list from "@/core/mixins/list";
import ServersTable from "@/components/Servers/features/ServersTable";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";


export default {
  name: "ServersList",
  components: { Search, ServersTable },
  mixins: [list],
  data() {
    return {
      fetch: false,
      query: "",
    };
  },
  computed: {
    ...mapState("servers", {
      total: (state) => state.servers.total,
      count: (state) => state.servers.count,
    }),
    ...mapGetters("servers", ["getQuery"]),
  },
  created() {
    this.setList({
      data: [],
      total: 0,
      count: 50,
    });
  },
  methods: {
    ...mapActions("servers", {
      getList: "GET_SERVERS_LIST",
    }),
    ...mapMutations("servers", {
      setQuery: "SET_QUERY",
      setList: "SET_LIST_SERVERS",
    }),
  },
};
</script>

<style lang="postcss">
.list,
.list__pagination {
  margin: 20px 0;
}
.list__pagination {
  text-align: center;
}
[class^="color_"] {
  font-weight: bold;
}
.el-table th > .cell {
  word-break: break-word;
}
</style>
